import React from 'react';
import Dashboard from '../components/Auth/Dashboard';

const DashboardPage: React.FC = () => {
    return (
        <div >
            <Dashboard />
        </div>
    );
};

export default DashboardPage;